// plugins/vuetify.ts
import { createVuetify } from 'vuetify';
import 'vuetify/styles';
import * as components from "vuetify/components"; // Import tất cả component
import * as directives from "vuetify/directives"; // Import tất cả directive
import * as labsComponents from 'vuetify/labs/components';
import { ja } from 'vuetify/locale';

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    components : {
      ...components,
      ...labsComponents,
    },
    directives,
    locale: {
      locale: 'ja',
      messages: {
        ja: {
          ...ja,
          open: '開く',
          noDataText: 'データがありません'
        },
      },
    },
  });
  
  nuxtApp.vueApp.use(vuetify)
})